import { belongsTo } from 'mewe/utils/store-utils/model/attribute';
import SimpleUser from 'mewe/stores/models/simple-user-model';
import { ds } from 'mewe/stores/ds';

export const modelOwner = {
  owner: belongsTo(SimpleUser, {
    defaultValue: function () {
      // both userId and ownerId can occur, depends on particular API
      const userId = this.userId || this.ownerId;
      return ds.authors[userId] || this.user;
    },
  }),
};
